export const adaptAnswers = ({
    data, values, groupId, isEmptyGroup = false,
}: any) => ({
    ...data,
    Groups: data?.Groups?.reduce((acc, group) => {
        acc.push({
            ...group,
            Steps: group.Steps.map((step) => ({
                ...step,
                Questions: step.Questions.map((question) => {
                    const answer = values?.[group.Id]?.[question.Id];
                    let answerToSet;

                    if (typeof answer === 'string') answerToSet = { Value: answer };
                    else if (typeof answer === 'number') answerToSet = { Ids: [answer] };
                    else if (!answer && isEmptyGroup) answerToSet = { Ids: [] };
                    else answerToSet = { Ids: answer };

                    return answer != null || (!answer && isEmptyGroup) ? { ...question, Value: answerToSet } : question;
                }),
            })),
        });

        return acc;
    }, []),
});

export const adaptInvestorProfileAnswers = ({ concurrencyToken = null, answers, qualityCheckQuestionnaire = null } : any) => {
    const updatedAnswers = answers;

    if (answers?.Groups?.length < 2) {
        updatedAnswers.Groups = updatedAnswers?.Groups?.concat(qualityCheckQuestionnaire);
    }

    return {
        QuestionnaireId: answers.Id,
        Groups: updatedAnswers?.Groups?.map(group => ({
            Id: group.Id,
            Questions: group.Steps.flatMap(step => step.Questions.map(question => ({
                Id: question.Id,
                ...(question.Value?.Value && { AnswerText: question.Value?.Value }),
                ...(question.Value?.Ids && { AnswerIds: question.Value?.Ids || [] }),
            }))),
        })),
        ConcurrencyToken: concurrencyToken,
    };
};
